import React from "react";
import "../Css/Impact.css";

const Impact = () => {
  return (
    <div className="impact">      
      <div className="kpis">
        <div className="kpi">
          <div className="value gradient-text">Seattle</div>
          <div className="label">Chapter</div>
        </div>
        <div className="kpi">
          <div className="value gradient-text">7</div>
          <div className="label">Athletes Empowered</div>
        </div>        
        <div className="kpi">
          <div className="value gradient-text">$700</div>
          <div className="label">Funds Raised</div>
        </div>
      </div>      
    </div>
  );
};

export default Impact;